import { ScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';
import { GetListProductResponse, ListPurchaseOrderHistory, ListPurchaseOrderHistoryRequest, ProductClient, ProductStatusEnum } from 'src/app/shared/api-connector/sso-connector';
import { AlertService } from 'src/app/shared/services/alert.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { NavService } from 'src/app/shared/services/nav.service';
import { UploadService } from 'src/app/shared/services/upload.service';
import { ProductImageDialogComponent } from '../../product-image-dialog/product-image-dialog.component';
import { EditThuocDrawerComponent } from '../../drawer/edit-thuoc-drawer/edit-thuoc-drawer.component';
import { DrawerService } from 'src/app/shared/components/drawer/drawer.service';

@Component({
  selector: 'app-detail-thuoc-dialog',
  templateUrl: './detail-thuoc-dialog.component.html',
  styleUrls: ['./detail-thuoc-dialog.component.scss']
})
export class DetailThuocDialogComponent implements OnInit {
  imageList: string[] = [];
  mainImgUrl: string = "";
  scrollStrategy: ScrollStrategy;
  isShowPaginator: boolean;
  count: number;
  purchaseOrderHistories: ListPurchaseOrderHistory[] = [];
  advancePage: number;
  constructor(
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<DetailThuocDialogComponent>,
    private alertService: AlertService,
    @Inject(MAT_DIALOG_DATA) public data: GetListProductResponse,
    private productClient: ProductClient,
    private uploadService: UploadService,
    private dialog: MatDialog,
    private readonly scrollStrategyOptions: ScrollStrategyOptions,
    public navService: NavService,
    private auth: AuthService,
    private drawerService: DrawerService
  ) {
    this.imageList = this.data.files;
    this.advancePage = 1;
  }

  CMS_PRODUCT_DELETE: boolean = false;
  CMS_PRODUCT_UPDATE: boolean = false;
  CMS_PRODUCT_UPDATE_STATUS: boolean = false;
  ngOnInit(): void {
    this.navService.checkPermission('CMS_PRODUCT_DELETE').subscribe(x => this.CMS_PRODUCT_DELETE = x);
    this.navService.checkPermission('CMS_PRODUCT_UPDATE').subscribe(x => this.CMS_PRODUCT_UPDATE = x);
    this.navService.checkPermission('CMS_PRODUCT_UPDATE_STATUS').subscribe(x => this.CMS_PRODUCT_UPDATE_STATUS = x);
    this.scrollStrategy = this.scrollStrategyOptions.noop();
    this.getListPurchaseOrderHistory();
  }


  getDetail() {
    this.spinner.show();
    this.productClient.getDetail(this.data.id)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe(x => {
        this.data = x;
        this.imageList = x.files;
      });
  }

  pageChangeData(event) {
    this.advancePage = event;
    this.getListPurchaseOrderHistory();
  }

  getListPurchaseOrderHistory() {
    this.spinner.show();
    this.productClient.listPurchaseOrderHistory(new ListPurchaseOrderHistoryRequest({
      productId: this.data.id,
      pageIndex: this.advancePage - 1,
      pageSize: 10,
    }))
      .pipe(finalize(() => {
        this.spinner.hide();
        this.isShowPaginator = true;
      }))
      .subscribe(x => {
        this.count = x.count;
        this.purchaseOrderHistories = x.items;
        // console.log("x.items;", x.items);
      });
  }

  close() {
    this.dialogRef.close();
  }

  getUrlFile(id: string) {
    return this.uploadService.getUrlFile(id);
  }

  onClickImg(id: string) {
    this.mainImgUrl = this.uploadService.getUrlFile(id);
  }

  onOpenUpdate() {
    const drawerRef = this.drawerService.open(EditThuocDrawerComponent, {
      title: 'Sửa sản phẩm: ' + this.data.title,
      width: '80%',
      disableClose: true,
      data: this.data
    });

    drawerRef.afterClosed().subscribe(x => {
      if (x) {
        this.getDetail();
      }
    });
  }

  onDeactive() {
    this.alertService.confirm('Bạn có chắc chắn muốn ngừng kinh doanh sản phẩm này không?', 'Cập nhật trạng thái sản phẩm')
      .subscribe(x => {
        if (x) {
          this.spinner.show();
          this.productClient.updateStatus(this.data.id, ProductStatusEnum.DEACTIVE)
            .pipe(finalize(() => this.spinner.hide()))
            .subscribe(z => {
              this.alertService.success('Ngừng kinh doanh sản phẩm thành công', 'Ngừng kinh doanh sản phẩm');
              this.dialogRef.close(true);
            });
        }
      });
  }

  openImage() {
    const dialogRef = this.dialog.open(ProductImageDialogComponent, {
      panelClass: 'custom-dialog',
      minWidth: 'auto',
      width: 'auto',
      height: '80%',
      disableClose: true,
      scrollStrategy: this.scrollStrategy,
      data: this.mainImgUrl
    });
  }
}
